const RentalConditionsGuaranteeIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="24" fill="#F4EFED" />
    <mask
      id="mask0_4219_1307"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="12"
      y="12"
      width="24"
      height="24"
    >
      <rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4219_1307)">
      <path
        d="M18.6925 34.5V26.9098L15.356 21.5L19.6732 14.5H28.3272L32.6445 21.5L29.308 26.9098V34.5L24.0002 32.702L18.6925 34.5ZM20.1925 32.3788L24.0002 31.1115L27.808 32.3788V28.5H20.1925V32.3788ZM20.5097 16L17.1097 21.5L20.5097 27H27.4907L30.8907 21.5L27.4907 16H20.5097ZM22.9502 25.2192L19.756 22.05L20.8252 20.9807L22.9502 23.1058L27.1752 18.8557L28.2445 19.9L22.9502 25.2192Z"
        fill="#0D0D0D"
      />
    </g>
  </svg>
);

export default RentalConditionsGuaranteeIcon;
